// state
const state = {
  stationsAeroAllergenGis: null,
  stationsWeatherGis: null,
  stationsTheNoiseGis: null,
  stationsAirQualityGis: null,
  layers: {
    airQuality: ['airQuality', 'UPDATE_STATIONS_AIR_QUALITY_GIS'],
    weather: ['weather', 'UPDATE_STATIONS_WEATHER_GIS'],
    aeroAllergen: ['aeroAllergen', 'UPDATE_STATIONS_AERO_ALLERGEN_GIS'],
    theNoise: ['noiseLevel', 'UPDATE_STATIONS_THE_NOISE_GIS']
  }
}

// getters
const getters = {
  getStationsAirQualityGisData (state) {
    return state.stationsAirQualityGis
  },
  getStationsAeroAllergenGisData (state) {
    return state.stationsAeroAllergenGis
  },
  getStationsWeatherGisData (state) {
    return state.stationsWeatherGis
  },
  getStationsTheNoiseGisData (state) {
    return state.stationsTheNoiseGis
  }
}

// actions
const actions = {
  // Update Data Gis
  getEnvironmentGis ({ commit, state }, data) {
    const store = this
    state.stationsAirGis = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/environmentGis',
      data: null,
      params: {
        type: data[0],
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: data[1]
    }
    store.dispatch('callService', dataService)
  },

  // Update All Stations Gis
  getAllStations ({ commit, state }) {
    const store = this
    store.dispatch('getEnvironmentGis', state.layers.airQuality)
    store.dispatch('getEnvironmentGis', state.layers.aeroAllergen)
    store.dispatch('getEnvironmentGis', state.layers.weather)
    store.dispatch('getEnvironmentGis', state.layers.theNoise)
  }
}

// mutations
const mutations = {
  UPDATE_STATIONS_AIR_QUALITY_GIS (state, data) {
    state.stationsAirQualityGis = data
  },
  UPDATE_STATIONS_AERO_ALLERGEN_GIS (state, data) {
    state.stationsAeroAllergenGis = data
  },
  UPDATE_STATIONS_WEATHER_GIS (state, data) {
    state.stationsWeatherGis = data
  },
  UPDATE_STATIONS_THE_NOISE_GIS (state, data) {
    state.stationsTheNoiseGis = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardEnvironment.js